import { Theme } from '../Theme'

export const TEST_ID_BY_THEME: Record<Theme, string> = {
  [Theme.AP]: 'afterpay-logo',
  [Theme.Pegasus]: 'arcade-afterpay-logo',
  [Theme.Kelpie]: 'arcade-afterpay-pill-logo',
  [Theme.Cash]: 'cash-afterpay-logo',
}
